export default __webpack_public_path__ + "static/media/HomeDark.06738b1c.svg";